import { createRoute } from '@tanstack/react-router';
import BookingConfirmationPage from '@/features/public/booking/pages/BookingConfirmationPage.tsx';
import { queryClient } from '@/App.tsx';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingRoute } from '@/features/public/booking/routes/bookingRoutes.ts';

export const bookingConfirmationRoute = createRoute({
  getParentRoute: () => bookingRoute,
  path: '/confirmation',
  component: BookingConfirmationPage,
  loader: async ({ params }) => {
    const { orgSlug, tourSlug } = params;
    const tourBasicInfo = await queryClient.fetchQuery({
      queryKey: bookingApiQueryKeys.basicInfo(orgSlug, tourSlug),
      queryFn: () => bookingApi.getBasicTourInfo(orgSlug, tourSlug),
    });
    return {
      tourBasicInfo,
    };
  },
});
